import isPlainObject from 'lodash-es/isPlainObject';
import { getRequiredStringValue, getRequiredValue } from './ConfigurationHelpers';
export function parseServiceConfig(config) {
    if (isPlainObject(config)) {
        const serviceConfig = getRequiredValue('services', config);
        if (isPlainObject(serviceConfig)) {
            const authServiceApiRoot = getRequiredStringValue('authServiceApiRoot', serviceConfig);
            const platformCoreApiRoot = getRequiredStringValue('platformCoreApiRoot', serviceConfig);
            const platformCoreWsRoot = getRequiredStringValue('platformCoreWsRoot', serviceConfig);
            return {
                authServiceApiRoot,
                platformCoreApiRoot,
                platformCoreWsRoot,
            };
        }
    }
    throw new Error('An error occured parsing service configuration');
}
//# sourceMappingURL=ServiceConfiguration.js.map